import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import { inertMaterials } from "./elements";
import ElementSelect from "./ElementSelect";
import ElementPercentageField from "./ElementPercentageField";
import ElementValue from "./ElementValue";
import RemoveElementButton from "./RemoveElementButton";
import { ResponsiveCell, ResponsiveFooter } from "../../ui/ResponsiveTable";

const Element = ({ element, onElementChange, onElementRemoved }) => {

    const isInertMaterial = element.elementId === inertMaterials.id;
    
    return (
        <React.Fragment>
            <ResponsiveCell width="40%">
                <ElementSelect
                    element={element}
                    onChange={onElementChange}
                    disabled={isInertMaterial}
                />
            </ResponsiveCell>
            <ResponsiveCell width="20%" align="right">
                <ElementPercentageField
                    element={element}
                    onChange={onElementChange}
                    disabled={isInertMaterial}
                />
            </ResponsiveCell>
            <ResponsiveCell width="20%" align="right" style={{paddingRight:"20px"}}>
                Value
                <ElementValue value={element.value} />
            </ResponsiveCell>
            <ResponsiveFooter width="20%">
                {!isInertMaterial && <RemoveElementButton element={element} onElementRemoved={onElementRemoved} />}
            </ResponsiveFooter>
        </React.Fragment>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
    };
};

const mapDispatchToProps = {
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Element));